const digest = '3abc49a91f8fe7223f2e07d4a77ca7f6cae86a915a6382d8eb755761049a2b48';
const css = `._marketingArticlesWrapper_107mx_1{@media (1024px <= width){>div{margin-inline:-12px}}}._cardWrapper_107mx_7{max-width:25%;padding-inline:12px}._cardWrapperUnder4Articles_107mx_12{max-width:33.3%;padding-inline:12px}._progressWrapper_107mx_17{height:500px}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'marketingArticlesWrapper': '_marketingArticlesWrapper_107mx_1', 'cardWrapper': '_cardWrapper_107mx_7', 'cardWrapperUnder4Articles': '_cardWrapperUnder4Articles_107mx_12', 'progressWrapper': '_progressWrapper_107mx_17' };
export const marketingArticlesWrapper = '_marketingArticlesWrapper_107mx_1';
export const cardWrapper = '_cardWrapper_107mx_7';
export const cardWrapperUnder4Articles = '_cardWrapperUnder4Articles_107mx_12';
export const progressWrapper = '_progressWrapper_107mx_17';
export { css, digest };